import { useParseContentForExamCourseComment } from '@exam-management/rich-text-editor';
import { ContentPreviewer } from '@shared/components';
import { useCallback, useEffect, useState } from 'react';

function useParseExamCourseComment(content: string, taskId: string) {
  const { parseContentForQSet } = useParseContentForExamCourseComment({ taskId });
  const [parsedContent, setParsedContent] = useState('');

  const handleParsedImage = useCallback(async () => {
    if (!content) return;

    const parsedContent = await parseContentForQSet(content);

    setParsedContent(parsedContent);
  }, [content, parseContentForQSet]);

  useEffect(() => {
    handleParsedImage();
  }, [handleParsedImage]);

  return {
    content: parsedContent,
  };
}

interface CommentRichTextPreviewerProps {
  content: string;
  taskId: string;
}

export default function CommentRichTextPreviewer(props: Readonly<CommentRichTextPreviewerProps>) {
  const { content, taskId } = props;
  const { content: parsedContent } = useParseExamCourseComment(content, taskId);

  return <ContentPreviewer content={parsedContent} />;
}
